import styled from 'styled-components'

export const Wrap = styled.div`
  height: 100%;
  width: 100%;
`
